import InviteEmployeesTriggerUrl from './inviteEmployeesTrigger.html';

class InviteEmployeesTriggerComponent {
  constructor(ShiftUtils) {
    'ngInject';

    Object.assign(this, { ShiftUtils });
  }
}

export default {
  controller: InviteEmployeesTriggerComponent,
  controllerAs: 'ctrl',
  templateUrl: InviteEmployeesTriggerUrl,
  bindings: {
    currentPeriodDays: '<',
    todayString: '<',
    setShouldOpenInviteEmployeesModal: '&',
  },
};
